import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOrderMSContactListData } from './mockData'
import type { IOrderMSContact } from '~/types/order/models'

interface GetOrderMSContactsResponse {
  data: IOrderMSContact[] | undefined
}

const postOrderMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOrderMSContactListData)
}

const patchOrderMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderMSContactListData)
}

const deleteOrderMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOrderMSContactListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/ordermscontacts',
    handler: postOrderMSContact,
  },
  {
    method: 'patch',
    path: '/api/ordermscontacts/:id',
    handler: patchOrderMSContact,
  },
  {
    method: 'delete',
    path: '/api/ordermscontacts/:id',
    handler: deleteOrderMSContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
